import { useNuxtApp } from '#app'

export function useTrackEvent() {
  const { $posthog } = useNuxtApp()

  function capture(eventName: string, properties?: Record<string, unknown>) {
    $posthog.capture(eventName, properties)
  }

  function captureException(error: unknown) {
    $posthog.captureException(error)
  }

  return { capture, captureException }
}
